var _helper = require('./helper');
var Constants = require('./constants');

/**
 * Boostrap modal template utility 
 */
module.exports = {

	_$tpl: function(cfg) {
		return $('.rs-modal-template', cfg.$container);		
	},

	_setBody: function($tpl, cfg) {
		var $body = $('.modal-body', $tpl);
		if(cfg.bodyUrl) {
			$body.load(cfg.bodyUrl, cfg.loadFn);
		}else{
			$body.append(cfg.$body.toggle(true));
		}
	},

	_show: function(cfg) {
		var self = this, 
			$tpl = self._$tpl(cfg);

		$('.modal-title', $tpl).empty().append(cfg.title);
		self._setBody($tpl, cfg);

		$tpl.on('show.bs.modal', cfg.show);
		$tpl.on('shown.bs.modal', cfg.shown);
		$tpl.on('hide.bs.modal', cfg.hide);

		$tpl.modal('show', $tpl);
	},

	show: function(cfg) {
		var self = this, 
			$tpl = self._$tpl(cfg);

		if($tpl.length === 0) {
		    var $c = $('<div class="modal-container">').appendTo(cfg.$container);
			$c.load(_helper.buildUrl(Constants.modalTemplateUrl), function() {
				self._show(cfg);
			});
		}

		$tpl.modal('show', $tpl);
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/commons/modalTpl.js
// module id = 250
// module chunks = 6